'use client';

import { GetActivitiesParams } from '@api/models';
import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { useLocale } from 'next-intl';

import { GetActivitiesResult, getActivities } from '../services/activities.service';

export function useActivities(
  params: GetActivitiesParams = {},
  options?: Omit<UseQueryOptions<GetActivitiesResult, Error>, 'queryKey' | 'queryFn'>
) {
  const locale = useLocale();
  const stableKey = JSON.stringify(params);

  return useQuery<GetActivitiesResult, Error>({
    queryKey: ['activities', locale, stableKey],
    queryFn: () => getActivities({ ...params, locale }),
    staleTime: 5 * 60 * 1000,
    placeholderData: (previousData) => previousData,
    ...options
  });
}
